.page {
  display: grid;
  place-items: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: var(--space-3);
  background: var(--color-canvas);
  color: var(--color-text-body);
}

.card {
  width: min(100%, 34rem);
  padding: clamp(24px, 5vw, 48px);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-overlay);
  background: var(--color-surface);
  box-shadow: var(--shadow-surface);
}

.eyebrow {
  margin: 0 0 var(--space-1);
  color: var(--color-accent);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.card h1 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: clamp(1.5rem, 4vw, 2rem);
  letter-spacing: -0.03em;
}

.description {
  margin: var(--space-1) 0 var(--space-3);
  color: var(--color-text-secondary);
  line-height: 1.55;
}

.form {
  display: grid;
  gap: var(--space-1);
}

.form label {
  color: var(--color-text-primary);
  font-weight: 700;
}

.form input {
  min-height: var(--target-min);
  padding-inline: 12px;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
  font: inherit;
}

.form input:focus-visible,
.primaryButton:focus-visible,
.secondaryButton:focus-visible {
  outline: 3px solid var(--color-accent);
  outline-offset: 2px;
}

.primaryButton,
.secondaryButton {
  min-height: var(--target-min);
  margin-block-start: var(--space-1);
  padding-inline: var(--space-2);
  border-radius: var(--radius-control);
  font: inherit;
  font-weight: 750;
  cursor: pointer;
}

.primaryButton {
  border: 1px solid var(--color-accent);
  background: var(--color-accent);
  color: #fff;
}

.primaryButton:hover {
  background: var(--color-accent-hover);
}

.secondaryButton {
  border: 1px solid var(--color-boundary);
  background: var(--color-surface);
  color: var(--color-text-primary);
}

.secondaryButton:hover {
  background: var(--color-surface-raised);
}

.primaryButton:disabled,
.secondaryButton:disabled,
.form input:disabled {
  cursor: wait;
  opacity: 0.65;
}

.error {
  margin: var(--space-2) 0 0;
  padding: var(--space-1) var(--space-2);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-control);
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

@media (forced-colors: active) {
  .card,
  .primaryButton,
  .secondaryButton,
  .error {
    border: 2px solid CanvasText;
  }
}
